import clsx from "clsx";
import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
    CIRCLEONE_USER,
    CIRCLEONE_USERNAME,
} from "../../../constants";
import { Dropdown } from "../../../helpers/components/Dropdown";
import { useLayout } from "../../../layout/core";
import { createInitials } from "../../../utils/functions/createInitials";
import { KTSVG } from "../../../helpers/components/KTSVG";
import { maskEmail } from "../../../utils/functions/maskData";





const SuperAdminTopRightTools: React.FC = () => {
    const { config } = useLayout();
    const [isUserMenuOpen, setIsUserMenuOpen] = useState<boolean>(false);
    const [isUserMenuOpen2, setIsUserMenuOpen2] = useState<boolean>(false);


    const headerUserDropdownMenuRef = useRef<HTMLDivElement>(null);
    

  const [closeTopRightTool, setCloseTopRightTool] = useState(false)



    // const [selectedTeam, setSelectedTeam] = useState<any>([]);
    const tenantName = localStorage.getItem(CIRCLEONE_USER);
    const userName = localStorage.getItem(CIRCLEONE_USERNAME);
    // const permissionToShow = localStorage.getItem("user-token");

    // useEffect(() => {
    //     if (permissionToShow) {
    //         const parsedPermission = JSON.parse(permissionToShow); // Parse the JSON string
    //         const teamPermissions = parsedPermission?.teams[0];
    //         // Find the key that you need dynamically
    //         const dynamicKey =
    //             Object.keys(teamPermissions).find((key) =>
    //                 key.includes("module_permissions")
    //             ) || Object.keys(teamPermissions)[0];
    //         const dynamicKey1 =
    //             Object.keys(teamPermissions).find(
    //                 (key) => key === "module_permissions"
    //             ) || Object.keys(teamPermissions)[0];
    //         if (dynamicKey1 === "module_permissions") {
    //             setModulePermission(true);
    //         } else {
    //             setModulePermission(false);
    //         }
    //         const permissionListValue = teamPermissions[dynamicKey] || []; // Ensure permissionListValue is an array
    //         setPermissionList(permissionListValue);
    //     }
    // }, [permissionToShow]);

    // const hasPermission = (permission) =>
    //     Array.isArray(permissionList) && permissionList.includes(permission);

    let initials = null;
    if (!!userName) {
        initials = createInitials(userName);
    }

    const closeUserMenu = () => {
        setIsUserMenuOpen(false);
        setIsUserMenuOpen2(false);
    };


    // const toolbarButtonMarginClass = "ms-lg-3";
    // const toolbarUserAvatarHeightClass = `symbol-30px symbol-md-40px ${isUserMenuOpen ? "show menu-dropdown" : ""
    //     }`;

    // const teamChange = (team: any) => {
    //     setSelectedTeam(team);
    //     openSaveModal();
    // };

 


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                headerUserDropdownMenuRef.current &&
                !headerUserDropdownMenuRef.current.contains(
                    event.target as Node
                )
            ) {
                closeUserMenu();
            }
        };
        if (closeTopRightTool) {
            closeUserMenu();
        }
    
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [closeTopRightTool]);

    // useEffect(() => {
    //     if (storeDResult) {
    //         setStoringServerConfigData(storeDResult);
    //     }
    // }, [storeDResult]);

    // const gettingQueues = localStorage.getItem(QUEUE);

    // useEffect(() => {
    //     if (gettingQueues) {
    //         // Split the comma-separated string into an array
    //         const queuesArray = gettingQueues.split(",");
    //         setQueueus(queuesArray);
    //     }
    // }, [gettingQueues]);



    return (
        <>
            <div
                className={clsx(
                    "d-flex align-items-center",
                    // toolbarButtonMarginClass
                )}
                ref={headerUserDropdownMenuRef}
            >
                {/* <div className="d-flex align-items-center">
                    <button className="btn btn-icon btn-sm btn-active-light-primary">
                        <i className="bi bi-bell-fill fs-1"></i>
                    </button>
                </div> */}
                <div
                    className={clsx(
                        "cursor-pointer symbol d-flex",
                        // toolbarUserAvatarHeightClass
                    )}
                >
                    <div className="dropdown ">
                        {/* <button
                            className="btn dropdown-toggle d-flex align-items-center text-dark fw-bolder my-1 fs-3"
                            type="button"
                            id="dropdownMenuButton3"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {teamName}
                        </button> */}
                        {/* {getTeamsById?.role === "admin" ? (
                            <ul className="dropdown-menu dropdown-menu-end p-2">
                                {teams
                                    ?.slice() // Create a shallow copy of teams to avoid mutating the original array
                                    .sort((a: any, b: any) =>
                                        a.name.localeCompare(b.name)
                                    ) // Sort teams alphabetically by name
                                    .map((team: any) => (
                                        <div
                                            key={team.id} // Ensure each team has a unique key
                                            className={`dropdown-item ${teamName === team.name
                                                ? "primary"
                                                : ""
                                                }`}
                                            onClick={() => teamChange(team)}
                                        >
                                            {team.name}
                                        </div>
                                    ))}
                            </ul>
                        ) : (
                            <ul className="dropdown-menu dropdown-menu-end p-2">
                                {getTeamsById?.teams
                                    ?.slice() // Create a shallow copy of teams to avoid mutating the original array
                                    .sort((a: any, b: any) =>
                                        a.name.localeCompare(b.name)
                                    ) // Sort teams alphabetically by name
                                    .map((team: any) => (
                                        <div
                                            key={team.id} // Ensure each team has a unique key
                                            className={`dropdown-item ${teamName === team.name
                                                ? "primary"
                                                : ""
                                                }`}
                                            onClick={() => teamChange(team)}
                                        >
                                            {team.name}
                                        </div>
                                    ))}
                            </ul>
                        )} */}
                    </div>

                    <span
                        className={`symbol-label bg-light-dark text-primary fs-6 fw-bolder`}
                        onClick={() => setIsUserMenuOpen2(!isUserMenuOpen2)}
                    >
                        {initials?.label}
                    </span>
                </div>
                <Dropdown
                    menuRef={headerUserDropdownMenuRef}
                    droppedDown={isUserMenuOpen2}
                    setDroppedDown={setIsUserMenuOpen}
                >
                    <div className="card-body">
                        <div className="menu-content d-flex align-items-center px-3">
                            <div className="symbol symbol-50px me-5">
                                <span
                                    className={`symbol-label bg-light-dark text-primary fs-6 fw-bolder`}
                                >
                                    {initials?.label}
                                </span>
                            </div>

                            <div className="d-flex flex-column">
                                <div className="fw-bolder d-flex align-items-center fs-5">
                                    {!!tenantName ? tenantName : "Unknown User"}
                                </div>
                                <span className="fw-bold text-muted text-hover-primary fs-7">
                                    {!!userName
                                        ? maskEmail(userName)
                                        : "abc@xyz.com"}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="separator my-2"></div>
                    <div className="menu-item px-5">
                        <Link
                            to="/profile"
                            onClick={closeUserMenu}
                            className="menu-link px-5"
                        >
                            My Profile
                        </Link>
                    </div>
                    <div className="separator my-2"></div>

                    {/* {tenantName === "victorinox" ? <span style={{color: "grey", padding: "4px 33px", cursor: "default"}}>Call History</span> : 
                    <div className="menu-item px-5">
                        <Link
                            to="/call-history"
                            onClick={closeUserMenu}
                            className="menu-link px-5"
                        >
                            Call History
                        </Link>
                    </div>
                    } */}
                    {/* <div className="separator my-2"></div> */}

                    {/* {hasPermission("phone:enable") && (
                        <>


                            <div className="menu-item px-5" style={{ paddingLeft: "0px", display: "flex", justifyContent: "flex-start" }}>
                                {tenantName === "victorinox" ? <span style={{padding: "5px 15px", color: "grey"}}>Telephony Login</span> : 
                                <div style={{ paddingLeft: "0px", display: "flex", justifyContent: "flex-start", width: "100%" }}>
                                    {!isLoggedIn ? (
                                        <span
                                        
                                            className="menu-link px-5"
                                            style={{
                                                border: "none",
                                                background: "transparent",
                                                // color: "#7e8299",
                                                // padding: "5px",
                                                width: "100%",
                                                paddingLeft: "0px",
                                                // color: "grey",
                                                // cursor: "default"

                                            }}
                                            onClick={telephonyHandler}
                                        >
                                            {loading ? (
                                                <LoadingSkeleton />
                                            ) : (
                                                "Telephony Login"
                                            )}
                                        </span>
                                    ) : (
                                        <span
                                            className="menu-link px-5"
                                            onClick={telephonyLogoutHandler}
                                            style={{
                                                border: "none",
                                                background: "transparent",
                                                // color: "grey",
                                                // color: "#7e8299",
                                                paddingLeft: "0px",

                                                width: "100%",
                                            }}
                                        >
                                            {loading ? (
                                                <LoadingSkeleton />
                                            ) : (
                                                "Telephony Logout"
                                            )}
                                        </span>
                                    )}
                                </div>
                    }
                            </div>
                            <div className="separator my-2"></div>
                        </>

                    )} */}

                    <div className="menu-item px-5">
                        <div
                            className={`menu-link px-5`}
                            onClick={(e) => {
                             
                                window.location.href = "/logout";
                            }}
                        >
                            Sign Out
                        </div>
                    </div>


                    {/* <div className="separator my-2"></div>
                    {location.pathname !== "/client-login" && (
                        <div className="menu-item px-5">
                            <Link to="/client-login" className="menu-link px-5">
                                Client
                            </Link>
                        </div>
                    )} */}
                </Dropdown>
            </div>

            {/* begin::Aside Toggler */}
            {config.header.left === "menu" && (
                <div
                    className="d-flex align-items-center d-lg-none ms-2 me-n3"
                    title="Show header menu"
                >
                    <div
                        className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
                        id="kt_header_menu_mobile_toggle"
                    >
                        <KTSVG
                            path="/media/icons/duotune/text/txt001.svg"
                            className="svg-icon-1"
                        />
                    </div>
                </div>
            )}

            {/* <ReactModal
                isOpen={isSaveModalOpen}
                onAfterOpen={afterOpenSaveModal}
                onRequestClose={closeSaveModal}
                style={customModalStyles}
                contentLabel="Save"
            >
                <SaveModal
                    closeSaveModal={closeSaveModal}
                    // selectedTeam={selectedTeam}
                />
            </ReactModal> */}
        </>
    );
};

export default SuperAdminTopRightTools;
